import { Box, Typography, SVGIcon, IconButton, KeyboardArrowRightIcon, CloseIcon } from 'src/components';
import { useIsMobile } from 'src/hooks';

export default function TableOfContentsPopup({ contents, onClick, onClose }) {
    const isMobile = useIsMobile();
    return (
        <Box sx={{ width: '100%' }}>

            <Box sx={{ display: 'flex', mb: 2, alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography
                    variant="h5"
                    fontWeight={600}
                    sx={{ color: 'text.primary' }}>
                    Article Contents
                </Typography>

                <IconButton 
                    onClick={onClose}
                    size="small" >
                        <CloseIcon fontSize={isMobile ? undefined : "inherit"}/>
                </IconButton>
            </Box>

            <Box
                sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                overflow: 'hidden',
                }}
            >
                {contents.map((item, index) => (
                <Box
                    key={index}
                    onClick={() => onClick(item.id)}
                    sx={{
                    display: 'flex',
                    alignItems: 'center',
                    px: 1.5,
                    py: 0.75,
                    cursor: 'pointer',
                    backgroundColor: 'background.paper',
                    transition: 'background 0.2s',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                    },
                    borderTop: index === 0 ? 'none' : '1px solid',
                    borderColor: 'divider',
                    }}
                >
                    <Box sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
                    <SVGIcon icon={item.icon} size={24} />
                    </Box>

                    <Typography variant="body2" sx={{ flexGrow: 1 }}>
                    {item.text}
                    </Typography>

                    <IconButton size="small" sx={{ color: 'text.secondary' }}>
                    <KeyboardArrowRightIcon fontSize="inherit" />
                    </IconButton>
                </Box>
                ))}
            </Box>
        </Box>
    );
}
